import { z } from 'zod'

const AssessorDateSchema = z
  .object({
    value: z.string().nullable(),
  })
  .nullable()

export const AssessorDataSchema = z.object({
  owner_name1_full: z.string().nullable(),
  owner1_first_name: z.string().nullable(),
  owner1_middle_name: z.string().nullable(),
  owner1_last_name: z.string().nullable(),
  owner1_suffix: z.string().nullable(),
  owner_name2_full: z.string().nullable(),
  owner2_first_name: z.string().nullable(),
  owner2_middle_name: z.string().nullable(),
  owner2_last_name: z.string().nullable(),
  owner2_suffix: z.string().nullable(),
  owner_occupied: z.string().nullable(),
  lot_size_sq_ft: z.number().nullable(),
  building_area: z.number().nullable(),
  year_built: z.string().nullable(),
  effective_year_built: z.string().nullable(),
  current_sale_recording_date: AssessorDateSchema,
  pool_code: z.string().nullable(),
  prev_sale_recording_date: AssessorDateSchema,
  owner1_corp_ind: z.string().nullable(),
  owner2_corp_ind: z.string().nullable(),
  current_sale_buyer1_full_name: z.string().nullable(),
  current_sale_buyer2_full_name: z.string().nullable(),
})
export type AssessorData = z.infer<typeof AssessorDataSchema>
